import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
});

export const getToken = () => {
  const store = JSON.parse(window.localStorage.getItem("readycash-report"));
  const token = store.user.user.bearer_token;
  return token;
};

export const getDefaultState = () => {
  return {
    error: null,
    success: null,
    status: null,
    signupError: null,
    loading: false,
    initialLoad: false,
    token: null,
    user: {},
    delay: 100,
    options: {
      duration: 2,
      useEasing: true,
      useGrouping: true,
      separator: ",",
      decimal: ".",
      prefix: "",
      suffix: "",
    },
    today: new Date().toISOString().slice(0, 10),
  };
};

export const resetState = () => {
  window.localStorage.removeItem("readycash-report");
  router.go({ path: "/login" });
};
